import React from 'react';
import { connect } from 'react-redux';

import { makeGetTaskNotifications } from 'selectors/notifications';

import NotificationsBubble from 'components/NotificationsBubble';

const TaskNotificationsBubble = ({ notificationsCount }) => (
    <NotificationsBubble count={notificationsCount} className="task-notifications-bubble" />
);

const makeMapStateToProps = () => {
    const getTaskNotifications = makeGetTaskNotifications();

    return ({ notifications }, ownProps) => {
        return {
            notificationsCount: (ownProps.id ? getTaskNotifications(notifications.items, ownProps.id) : []).length
        }
    }
}

export default connect(makeMapStateToProps)(TaskNotificationsBubble);
